export default {
  'call-dispatcher': '디스패처에게 전화하기',
  'error-code': '오류 {code}',
  'dispatcher-hint': '이 오류가 표시되면 Rx2Go 디스패처에게 문의하세요',
  400: {
    title: '잘못된 요청',
    description: '클릭한 링크에 문제가 있어 요청을 처리할 수 없습니다.',
  },
  404: {
    title: '페이지를 찾을 수 없음',
    description: '찾으시는 페이지가 삭제되었거나, 이름이 변경되었거나, 일시적으로 사용할 수 없습니다.',
  },
  500: {
    title: '낶부 서버 오류',
    description: '예상치 못한 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
  },
  generic: {
    title: '문제가 발생했습니다',
    description: '문제가 발생했습니다',
  },
}
